<template>
  <main>
    <div class="container">
      <div class="page_content"
           v-if="htmlContent"
           v-html="htmlContent" />
      <TheContacts />
    </div>
  </main>
</template>

<script setup lang="ts">
import { TheContacts } from '@/components';
import type { IContactsPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IContactsPage>('page-contact', {
  populate: 'deep',
});

const data = response.data as unknown as IContactsPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;
</script>
